import { render } from "./ClipPanel.vue?vue&type=template&id=5d3c6e23"
import script from "./ClipPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./ClipPanel.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/LiveClipping/ClipPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5d3c6e23"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5d3c6e23', __exports__)) {
    api.reload('5d3c6e23', __exports__)
  }
  
  module.hot.accept("./ClipPanel.vue?vue&type=template&id=5d3c6e23", () => {
    api.rerender('5d3c6e23', render)
  })

}


export default __exports__